import React, { useEffect, useRef, useState } from 'react';
const SpendingTrackerSimple = ({ title, cartTotal, firstTierThreshold, secondTierThreshold, firstTierMessage, secondTierMessage, firstTierLabel, secondTierLabel, firstTierCost, secondTierCost }) => {
    const trackerRef = useRef();
    const firstTierRef = useRef();
    const firstTierDotRef = useRef();
    const secondTierDotRef = useRef();
    const [promptMessage, setPromptMessage] = useState('');
    useEffect(() => {
        let trackerWidth = 0;
        if (trackerRef && trackerRef.current) {
            if (cartTotal > secondTierThreshold) {
                trackerWidth = 100;
            }
            else {
                trackerWidth = (cartTotal / secondTierThreshold) * 100;
            }
            trackerRef.current.style.width = `${trackerWidth}%`;
        }
        if (firstTierRef && firstTierRef.current) {
            const labelPosition = (firstTierThreshold / secondTierThreshold) * 100;
            firstTierRef.current.style.left = `${labelPosition}%`;
            firstTierDotRef.current.style.left = `${labelPosition}%`;
        }
        if (cartTotal > secondTierThreshold && secondTierMessage !== '') {
            setPromptMessage(secondTierMessage);
        }
        else if (cartTotal > firstTierThreshold && firstTierMessage !== '') {
            setPromptMessage(firstTierMessage);
        }
    }, [cartTotal, firstTierThreshold, secondTierThreshold]);
    if (!firstTierThreshold || !secondTierThreshold) {
        return null;
    }
    return (React.createElement("div", { className: "spending-tracker__header--bar" },
        React.createElement("div", { className: "spending-tracker__bar" },
            React.createElement("span", { className: "spending-tracker__bar--tracker", ref: trackerRef }),
            React.createElement("span", { className: `spending-tracker__bar--dot${cartTotal > firstTierThreshold ? ' over-threshold' : ''}`, ref: firstTierDotRef }),
            React.createElement("span", { className: `spending-tracker__bar--dot spending-tracker__bar--dot-secondary${cartTotal > secondTierThreshold ? ' over-threshold' : ''}`, ref: secondTierDotRef }),
            React.createElement("span", { className: "spending-tracker__bar--label first-tier-label", ref: firstTierRef },
                React.createElement("span", { className: "spending-tracker__bar--tier-text" }, firstTierLabel),
                React.createElement("span", { className: "spending-tracker__bar--tier-label" }, firstTierCost)),
            React.createElement("span", { className: "spending-tracker__bar--label second-tier-label" },
                React.createElement("span", { className: "spending-tracker__bar--tier-text" }, secondTierLabel),
                React.createElement("span", { className: "spending-tracker__bar--tier-label" }, secondTierCost)))));
};
export default SpendingTrackerSimple;
